module.exports = __webpack_public_path__ + "img/gerenciador-contas-instagram-icon.6fd03af0.svg";